import { useMemo } from 'react';

import { TriggerCategory, TriggerCategoryType } from '@/modules/HealthPlan/HealthPlan.types.ts';

interface TriggerItem {
  triggerCategoryType?: TriggerCategoryType | string;
}

/**
 * Determines if the Health Plan has only Embedded triggers (no Family triggers).
 * When true, certain UI sections like "Lock Card Purse" should be hidden.
 *
 * @param triggersPerTier - array of trigger arrays (one per tier)
 */
const useIsEmbeddedOnly = (triggersPerTier: TriggerItem[][]): boolean => {
  return useMemo(() => {
    const hasTriggers = triggersPerTier.some((triggers) => triggers.length > 0);
    if (!hasTriggers) return false;

    const hasFamilyTrigger = triggersPerTier.some((triggers) =>
      triggers.some((trigger) => trigger.triggerCategoryType === TriggerCategory.FAMILY)
    );

    return !hasFamilyTrigger;
  }, [triggersPerTier]);
};

export default useIsEmbeddedOnly;
